// Modules
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import { DeemphasizedNegativeButton } from 'components/widgets/buttons';
import { FormCard } from 'components/content-containers/cards';
import { Page, PageHeader, ActionSection, PageContent } from 'components/page';
import { SVGButton } from 'components/widgets/buttons/buttons';
import { XeroInvoiceLink, GoogleDriveLink } from 'components/widgets/icons/link-icons';
import { alerts } from 'modules/alerts/actions';
import { actions as modalActions } from 'modules/modals/actions';
import Invoice from 'services/data/invoice';
import InvoiceForm from 'components/models/invoice/invoice-form';
import Person from 'services/data/person';
import SVG from 'components/widgets/icons/svg';
import appHistory from 'app-history';

import * as actions from './store/actions';


// Component
class ViewInvoice extends React.Component {
  static propTypes = {
    invoicePDF: PropTypes.string,
    invoiceId: PropTypes.string,
    currentUser: PropTypes.object,
    invoice: PropTypes.object,
    fetching: PropTypes.bool,
    deleting: PropTypes.bool,
    deleted: PropTypes.bool
  };

  constructor() {
    super();

    this.state = { editing: false };
    this.load = this.load.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.deleteInvoice = this.deleteInvoice.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.startEditing = () => this.setState({ editing: true });
    this.endEditing = () => this.setState({ editing: false });
  }

  componentWillMount() {
    this.load();
  }

  componentWillUnmount() {
    actions.set({ invoice: null, invoicePDF: null });
  }

  onSubmit(values) {
    return Invoice.update(values).then(() => {
      this.load();
      this.setState({ editing: false });
    });
  }

  load() {
    Invoice.getPDF(this.props.invoiceId)
      .then((response) => {
        actions.set({ invoice: response.invoice, invoicePDF: response.view });
      })
      .catch(alerts.catchError);
  }

  confirmDelete() {
    modalActions.showDeleteModal({
      onConfirm: this.deleteInvoice,
      title: 'Are you sure you want to delete this invoice?',
      body: 'All of the time reports, expense bills, and fixed billings for this invoice will show up on the billing page for you to optionally bill again.'
    });
  }

  deleteInvoice() {
    actions.set({ deleting: true });

    Invoice.delete(this.props.invoiceId)
      .then(() => {
        actions.set({ deleting: false });
        appHistory.push({ pathname: '/accounting/invoices', query: { setDefaultQuery: true } });
      })
      .catch((err) => {
        actions.set({ deleting: false });
        alerts.catchError(err);
      });
  }

  render() {
    const { invoicePDF, fetching, deleting, currentUser, invoice } = this.props;
    const { editing } = this.state;
    const initialValues = _.pick(invoice, ['id', 'dueDate', 'invoiceDate', 'purchaseOrderNumber', 'hideBillDetails', 'paymentMethod']);

    return (
      <Page>
        <PageHeader title="Invoice">
          {(!!Person.isLead(currentUser) || !!Person.isOperations(currentUser)) &&
            <ActionSection>
              {invoice && invoice.xeroId && <XeroInvoiceLink xeroId={invoice.xeroId} />}
              {invoice && invoice.invoiceNumber && invoice.pdf && <GoogleDriveLink fileId={invoice.pdf.fileId} className="margin-left" />}
              {invoice && <SVGButton onClick={this.startEditing} src="svg/edit.svg" className="edit-button edit-link" />}
              <div className="right-actions">
                {Person.isAdmin(currentUser) &&
                  <DeemphasizedNegativeButton
                    onClick={this.confirmDelete}
                    disabled={!invoicePDF || invoice.legacyId}
                    showLoading={deleting}
                  >
                    Delete Invoice
                  </DeemphasizedNegativeButton>
                }
              </div>
            </ActionSection>
          }
        </PageHeader>
        <PageContent fetching={fetching || !invoicePDF} className={classNames('invoice', { 'bg-medium-blue-grey': editing, 'p-5': !editing })}>
          {editing &&
            <FormCard className="invoice-form">
              <div className="form-header">
                <SVG src="svg/invoice-list.svg" className="invoice" />
                <h5 className="form-title">Edit Invoice</h5>
                <SVG onClick={this.endEditing} className="close" src="svg/close.svg" />
              </div>
              <InvoiceForm
                initialValues={initialValues}
                invoice={invoice}
                onSubmit={this.onSubmit}
              />
            </FormCard>
          }
          {!editing && <div dangerouslySetInnerHTML={{ __html: invoicePDF }} />}
        </PageContent>
      </Page>
    );
  }
}

// Exports
export default connect((state, ownProps) => ({
  invoicePDF: state.invoices.invoicePDF,
  invoice: state.invoices.invoice,
  fetching: state.invoices.fetching,
  deleting: state.invoices.deleting,
  deleted: state.invoices.deleted,
  invoiceId: ownProps.params.invoiceId,
  currentUser: state.auth.currentUser
}))(ViewInvoice);
